import { render, staticRenderFns } from "./UpdateRegistration.vue?vue&type=template&id=776bb8ec"
import script from "./UpdateRegistration.vue?vue&type=script&lang=js"
export * from "./UpdateRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports